import { SVGProps } from 'react';

export const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4 12H5.6V10.4H7.2V8H6.4V6.4H8C8.4416 6.4 8.8 6.7584 8.8 7.2V10.4H10.4V12ZM8 3.8C8.552 3.8 9 4.248 9 4.8C9 5.352 8.552 5.8 8 5.8C7.448 5.8 7 5.352 7 4.8C7 4.248 7.448 3.8 8 3.8ZM8 0C3.5888 0 0 3.5888 0 8C0 12.412 3.5888 16 8 16C12.4112 16 16 12.412 16 8C16 3.5888 12.4112 0 8 0Z"
      fill="currentColor"
    />
  </svg>
);
